export const NONE = Symbol("none");
